import { Navigate } from 'react-router-dom';
import { useTenant } from '../../context/TenantContext';
import { hasClasses } from '../../utils/publicProfile';

/**
 * Route guard for the class/session/attendance/training-journal world (Stage 2 gating). For
 * open-floor gym clubs these routes redirect to the portal dashboard instead of rendering — so a
 * hidden nav item can't be reached by typing the URL. Reversible: the moment a club's type runs
 * classes again, the route works with zero data loss. Byte-identical for every non-gym club.
 * Mirrors BeltGate exactly.
 */
export default function ClassGate({ redirectTo, children }) {
  const { club, loading } = useTenant();
  if (loading) return null;                   // wait for club type; avoids a wrong redirect flash
  if (!hasClasses(club?.clubType)) return <Navigate to={redirectTo} replace />;
  return children;
}
